import {InMemoryCache, IntrospectionFragmentMatcher} from 'apollo-cache-inmemory';
import possibleTypes from './possibleTypes.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: possibleTypes,
});

const createApolloCache = (): InMemoryCache => {
  return new InMemoryCache({fragmentMatcher});
};

export default createApolloCache;
